import { FC, useCallback, useEffect, useState, type JSX } from 'react';
import { useDispatch } from 'react-redux';

import { SortDirection } from '@payaca/types/listViewTypes';
import { ScheduledEvent } from '@payaca/types/scheduledEventsTypes';

import UpcomingScheduledEventsList from '../upcomingScheduledEventsList/UpcomingScheduledEventsList';

import { useSelector } from '@/api/state';

import * as scheduledEventActions from '@payaca/store/scheduledEvents/scheduledEventsActions';

const DashboardScheduledEventsList: FC = (): JSX.Element => {
  const dispatch = useDispatch();
  const [scheduledEvents, setScheduledEvents] = useState<ScheduledEvent[]>([]);

  const isGettingScheduledEvents = useSelector((state) => {
    return state.scheduledEvents.isGettingScheduledEvents;
  });

  const getScheduledEvents = useCallback(() => {
    dispatch(
      scheduledEventActions.requestGetListedScheduledEvents(
        {
          pageSize: 15,
          pageNumber: 0,
          start: new Date().toISOString(),
          sortDirection: SortDirection.ASCENDING,
        },
        setScheduledEvents
      )
    );
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has a missing dependency: 'dispatch'
  }, []);

  useEffect(() => {
    getScheduledEvents();
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'getScheduledEvents'
  }, []);

  return (
    <div className="dashboard-scheduled-events-list">
      <UpcomingScheduledEventsList
        scheduledEvents={scheduledEvents}
        getScheduledEvents={getScheduledEvents}
        isGettingScheduledEvents={isGettingScheduledEvents}
      />
    </div>
  );
};

export default DashboardScheduledEventsList;
